import Vue from 'vue'
import Router from 'vue-router'
import MainLayout from '@/layouts/MainLayout.vue'

Vue.use(Router)

const router = new Router({
    mode: 'hash',
    routes: [
        {
            path: '/login',
            name: 'login',
            meta: {title: '登录页面', icon: 'Key'},
            component: () => import('@/views/LoginPage.vue'),
        },
        {
            path: '/callback',
            name: 'callback',
            meta: {title: '登录回调', icon: 'Key'},
            component: () => import('@/views/WxCallback.vue'),
        },
        {
            path: '/dashboard',
            redirect: '/'
        },
        {
            path: '',
            component: MainLayout,
            children: [
                {
                    path: '/',
                    name: 'dashboard',
                    meta: {title: '数据总览', icon: 'DataBoard'},
                    component: () => import('@/views/Dashboard.vue'),
                },
                {
                    path: '/data-screen',
                    name: 'data-screen',
                    meta: {title: '数据大屏', icon: 'DataBoard'},
                    component: () => import('@/views/DataScreen/DataScreen.vue'),
                },
                {
                    path: '/data-screen-config',
                    name: 'data-screen-config',
                    meta: {title: '大屏数据配置', icon: 'Setting'},
                    component: () => import('@/views/DataScreen/DataScreenConfig.vue'),
                },
                {
                    path: "userList",
                    name: "UserList",
                    component: () => import("@/views/UserManage/UserList.vue"),
                    meta: {title: "用户管理"}
                },
                {
                    path: 'platform',
                    name: 'platform',
                    meta: {title: '微信开放平台', icon: 'Platform'}, // 一级菜单
                    component: {render: h => h('router-view')},
                    redirect: '/platform/platform-list',
                    children: [
                        {
                            path: 'platform-list',
                            name: 'platform-platform-list',
                            meta: {title: '平台列表', icon: 'List'},
                            component: () => import('@/views/Platform/PlatformList.vue'),
                        },
                        {
                            path: 'app-list',
                            name: 'platform-app-list',
                            meta: {title: '应用列表', icon: 'List'},
                            component: () => import('@/views/Platform/AppList.vue'),
                        },
                        {
                            path: 'template-list',
                            name: 'platform-template-list',
                            meta: {title: '模板消息列表', icon: 'List'},
                            component: () => import('@/views/Platform/TemplateList.vue'),
                        },
                        {
                            path: 'menu-manage',
                            name: 'platform-menu-manage',
                            meta: {title: '公众号菜单管理', icon: 'Menu'},
                            component: () => import('@/views/Platform/MenuManage.vue'),
                        },
                        {
                            path: 'media-list',
                            name: 'platform-media-list',
                            meta: {title: '媒体素材', icon: 'Picture'},
                            component: () => import('@/views/Platform/MediaList.vue'),
                        }
                    ]
                },
                {
                    path: 'other-platforms',
                    name: 'other-platforms',
                    meta: { title: '其它平台', icon: 'Cloudy' },
                    component: { render: h => h('router-view') },
                    redirect: '/other-platforms/baidu/account-list',
                    children: [
                        {
                            path: 'baidu',
                            name: 'other-platforms-baidu',
                            meta: { title: '百度', icon: 'Baidu' },
                            component: { render: h => h('router-view') },
                            redirect: '/other-platforms/baidu/account-list',
                            children: [
                                {
                                    path: 'speech-synthesis',
                                    name: 'other-platforms-baidu-speech-synthesis',
                                    meta: { title: '语音合成', icon: 'User' },
                                    component: () => import('@/views/OtherPlatforms/Baidu/SpeechSynthesis.vue'),
                                },
                            ]
                        },
                        {
                            path: 'douyin',
                            name: 'other-platforms-douyin',
                            meta: { title: '抖音', icon: 'VideoCamera' },
                            component: { render: h => h('router-view') },
                            redirect: '/other-platforms/douyin/account-list',
                            children: [
                                {
                                    path: 'account-list',
                                    name: 'other-platforms-douyin-account-list',
                                    meta: { title: '账号管理', icon: 'User' },
                                    component: () => import('@/views/OtherPlatforms/Douyin/AccountList.vue'),
                                },
                            ]
                        },
                        {
                            path: 'object-storage',
                            name: 'other-platforms-object-storage',
                            meta: { title: '对象存储', icon: 'Upload' },
                            component: { render: h => h('router-view') },
                            redirect: '/other-platforms/object-storage/server-manage',
                            children: [
                                {
                                    path: 'server-manage',
                                    name: 'other-platforms-object-storage-server-manage',
                                    meta: { title: '服务器管理', icon: 'SPromotion' },
                                    component: () => import('@/views/OtherPlatforms/ObjectStorage/ServerManage.vue'),
                                },
                                {
                                    path: 'file-manage',
                                    name: 'other-platforms-object-storage-file-manage',
                                    meta: { title: '文件管理', icon: 'Document' },
                                    component: () => import('@/views/OtherPlatforms/ObjectStorage/FileManage.vue'),
                                },
                            ]
                        },

                    ]
                },
                {
                    path: 'chater-manage',
                    name: 'ChaterManage',
                    meta: {title: '陪聊管理', icon: 'User'},
                    component: {render: h => h('router-view')},
                    redirect: '/chater-manage/user-list',
                    children: [
                        {
                            path: 'user-list',
                            name: 'ChaterManage-user-list',
                            meta: {title: '用户列表', icon: 'List'},
                            component: () => import('@/views/ChaterManage/UserList.vue'),
                        }
                    ]
                },
                {
                    path: 'agent',
                    name: 'agent',
                    meta: {title: '分公司管理', icon: 'UserFilled'},
                    component: {render: h => h('router-view')},
                    redirect: '/agent/list',
                    children: [
                        {
                            path: 'list',
                            name: 'agent-list',
                            meta: {title: '分公司列表', icon: 'List'},
                            component: () => import('@/views/AgentManage/AgentList.vue'),
                        },
                        {
                            path: 'promoter',
                            name: 'agent-promoter',
                            meta: {title: '代理管理', icon: 'User'},
                            component: () => import('@/views/AgentManage/PromoterManage.vue'),
                        },
                        {
                            path: 'promoter-manage',
                            name: 'agent-promoter-manage',
                            meta: {title: '推广员管理', icon: 'UserFilled'},
                            component: () => import('@/views/AgentManage/PromoterManage2.vue'),
                        },
                        {
                            path: 'agent-play-list',
                            name: 'agent-agent-play-list',
                            meta: {title: '分公司用户列表', icon: 'List'},
                            component: () => import('@/views/AgentManage/components/AgentPlayerList.vue'),
                        },
                        {
                            path: 'agent-chater-list',
                            name: 'agent-agent-chater-list',
                            meta: {title: '分公司用户列表', icon: 'List'},
                            component: () => import('@/views/AgentManage/components/AgentChaterList.vue'),
                        },
                        {
                            path: 'exchange-code-generate',
                            name: 'exchange-code-generate',
                            meta: {title: '兑换码生成', icon: 'Ticket'},
                            component: () => import('@/views/ExchangeCode/Generate.vue'),
                        },
                        {
                            path: 'exchange-code-list',
                            name: 'exchange-code-list',
                            meta: {title: '兑换码查询', icon: 'Search'},
                            component: () => import('@/views/ExchangeCode/List.vue'),
                        },
                        {
                            path: 'join-setting',
                            name: 'agent-join-setting',
                            meta: { title: '加入设置', icon: 'Setting' },
                            component: () => import('@/views/AgentManage/JoinSetting.vue'),
                        },
                        {
                            path: 'limit-setting',
                            name: 'agent-limit-setting',
                            meta: { title: '推广设置', icon: 'Tools' },
                            component: () => import('@/views/AgentManage/LimitSetting.vue'),
                        }
                    ]
                },
                {
                    path: 'order',
                    name: 'order',
                    meta: {title: '订单管理', icon: 'Document'},
                    component: {render: h => h('router-view')},
                    redirect: '/order/manual/make-order',
                    children: [
                        // {
                        //     path: 'DiyOrder',
                        //     name: 'order-manual',
                        //     meta: { title: '手工制单', icon: 'Edit' },
                        //     component: { render: h => h('router-view') },
                        //     redirect: '/order/manual/make-order',
                        //     children: [
                        //         {
                        //             path: 'make-order',
                        //             name: 'order-manual-make-order',
                        //             meta: { title: '代理制单', icon: 'Edit' },
                        //             component: () => import('@/views/OrderManage/DiyOrder/MakeOrder.vue'),
                        //         },
                        //         {
                        //             path: 'trade-list',
                        //             name: 'order-manual-trade-list',
                        //             meta: { title: '交易订单列表', icon: 'List' },
                        //             component: () => import('@/views/OrderManage/DiyOrder/TradeList.vue'),
                        //         }
                        //     ]
                        // },
                        {
                            path: 'chater',
                            name: 'order-chater',
                            meta: {title: '陪聊订单', icon: 'ChatDotRound'},
                            component: () => import('@/views/OrderManage/ChaterOrder.vue'),
                        },
                        {
                            path: 'album',
                            name: 'order-album',
                            meta: {title: '相册订单', icon: 'Picture'},
                            component: () => import('@/views/OrderManage/AlbumOrder.vue'),
                        },
                        {
                            path: 'play',
                            name: 'order-play',
                            meta: {title: '陪玩订单', icon: 'Headset'},
                            component: () => import('@/views/OrderManage/PlayOrder.vue'),
                        }
                    ]
                },
                {
                    path: '/finance',
                    name: 'finance',
                    meta: {title: '财务管理', icon: 'el-icon-money'},
                    component: {render: h => h('router-view')},
                    children: [
                        {
                            path: 'trade',
                            name: 'FinanceTrade',
                            meta: {title: '支付交易列表', icon: 'el-icon-tickets'},
                            component: () => import('@/views/Finance/TradeList.vue')
                        },
                        {
                            path: 'share',
                            name: 'FinanceShare',
                            meta: {title: '分润列表', icon: 'el-icon-share'},
                            component: () => import('@/views/Finance/ShareMoneyList.vue')
                        },
                        {
                            path: 'cash',
                            name: 'FinanceCash',
                            meta: {title: '提现列表', icon: 'el-icon-bank-card'},
                            component: () => import('@/views/Finance/CashList.vue')
                        },
                        {
                            path: 'refund-review',
                            name: 'FinanceRefundReview',
                            meta: {title: '退款审核', icon: 'el-icon-refresh-left'},
                            component: () => import('@/views/Finance/RefundReviewList.vue')
                        },
                        {
                            path: 'profit-config',
                            name: 'FinanceProfitConfig',
                            meta: {title: '收益分配设置', icon: 'el-icon-coin'},
                            component: () => import('@/views/Finance/ProfitConfig.vue')
                        },
                        {
                            path: 'shanyan-profit-config',
                            name: 'ShanyanProfitConfig',
                            meta: {title: '闪颜分利配置', icon: 'el-icon-coin'},
                            component: () => import('@/views/Finance/ShanyanProfitConfig.vue')
                        },
                        {
                            path: 'profit-record',
                            name: 'FinanceProfitRecord',
                            meta: {title: '分润明细', icon: 'el-icon-s-data'},
                            component: () => import('@/views/Finance/ProfitRecordList.vue')
                        },
                        {
                            path: 'shanyan-profit-record',
                            name: 'ShanyanProfitRecord',
                            meta: {title: '闪颜分润明细', icon: 'el-icon-s-data'},
                            component: () => import('@/views/Finance/ShanyanProfitRecord.vue')
                        }
                    ]
                },
                {
                    path: 'play',
                    name: 'play',
                    meta: {title: '陪玩管理', icon: 'Service'},
                    component: {render: h => h('router-view')},
                    redirect: '/play/user-list',
                    children: [
                        {
                            path: 'user-list',
                            name: 'play-user-list',
                            meta: {title: '陪玩用户列表', icon: 'User'},
                            component: () => import('@/views/PlayManage/PlayUserList.vue'),
                        },
                        {
                            path: 'item-list',
                            name: 'play-item-list',
                            meta: {title: '陪玩项目管理', icon: 'List'},
                            component: () => import('@/views/PlayManage/PlayItemList.vue'),
                        },
                        {
                            path: 'category-list',
                            name: 'play-category-list',
                            meta: {title: '陪玩类别管理', icon: 'Grid'},
                            component: () => import('@/views/PlayManage/PlayCategoryList.vue'),
                        },
                        // 新增：达人评论管理
                        {
                            path: 'comment-list',
                            name: 'play-comment-list',
                            meta: {title: '达人评论管理', icon: 'ChatDotRound'},
                            component: () => import('@/views/PlayManage/PlayCommentList.vue'),
                        }
                    ]
                },
                {
                    path: 'marketing',
                    name: 'marketing',
                    meta: { title: '营销管理', icon: 'Present' },
                    component: { render: h => h('router-view') },
                    redirect: '/marketing/coupon-list',
                    children: [
                        {
                            path: 'coupon-list',
                            name: 'marketing-coupon-list',
                            meta: { title: '优惠券', icon: 'Ticket' },
                            component: () => import('@/views/Marketing/CouponList.vue'),
                        },
                        {
                            path: 'giftpack-list',
                            name: 'marketing-giftpack-list',
                            meta: { title: '礼包', icon: 'Gift' },
                            component: () => import('@/views/Marketing/GiftPackList.vue'),
                        },
                        // ✅ 新增：推广码
                        {
                            path: 'promo-code',
                            name: 'marketing-promo-code',
                            meta: { title: '推广码', icon: 'Share' }, // icon 可按你项目的字典
                            component: () => import('@/views/Marketing/PromoCodeList.vue'),
                        },
                    ]
                },
                {
                    path: 'cities',
                    name: 'cities',
                    meta: {title: '城市管理', icon: 'Location'},
                    component: {render: h => h('router-view')},
                    redirect: '/cities/list',
                    children: [
                        {
                            path: 'list',
                            name: 'city-list',
                            meta: {title: '城市列表', icon: 'List'},
                            component: () => import('@/views/CityManage/CityList.vue'),
                        }
                    ]
                },
                {
                    path: 'groupchat',
                    name: 'groupchat',
                    meta: {title: '闪颜群聊', icon: 'ChatDotRound'},
                    component: {render: h => h('router-view')},
                    redirect: '/groupchat/shanyan-group',
                    children: [
                        {
                            path: 'shanyan-members/:groupId',
                            name: 'groupchat-shanyan-members',
                            meta: { title: '闪颜群成员' },
                            component: () => import('@/views/GroupchatManage/ShanyanGroupMemberList.vue'),
                        },
                        {
                            path: 'shanyan-messages/:groupId',
                            name: 'groupchat-shanyan-messages',
                            meta: { title: '闪颜群消息' },
                            component: () => import('@/views/GroupchatManage/ShanyanGroupMessageList.vue'),
                        },
                        {
                            path: 'members/:groupId',
                            name: 'groupchat-members',
                            meta: { title: '群用户列表' },
                            component: () => import('@/views/GroupchatManage/GroupMemberList.vue'),
                        },
                        {
                            path: 'messages/:groupId',
                            name: 'groupchat-messages',
                            meta: { title: '群消息列表' },
                            component: () => import('@/views/GroupchatManage/GroupMessageList.vue'),
                        },
                        {
                            path: 'shanyan-group',
                            name: 'shanyan-group',
                            meta: { title: '闪颜社群管理', icon: 'ChatSquare' },
                            component: () => import('@/views/GroupchatManage/ShanyanGroupList.vue'),
                        },
                        {
                            path: 'owner-audit',
                            name: 'groupchat-owner-audit',
                            meta: { title: '群主审核', icon: 'UserFilled' },
                            component: () => import('@/views/GroupchatManage/GroupOwnerAudit.vue'),
                        },
                        {
                            path: 'fadan-manage',
                            name: 'groupchat-fadan-manage',
                            meta: { title: '订单管理', icon: 'Document' },
                            component: () => import('@/views/GroupchatManage/GroupchatFadanManage.vue'),
                        },
                        {
                            path: 'shanyan-order-card',
                            name: 'groupchat-shanyan-order-card',
                            meta: { title: '订单消息管理', icon: 'DocumentCopy' },
                            component: () => import('@/views/GroupchatManage/ShanyanOrderCardManage.vue'),
                        },
                        {
                            path: 'quick-phrase',
                            name: 'groupchat-quick-phrase',
                            meta: { title: '快捷语管理', icon: 'Message' },
                            component: () => import('@/views/GroupchatManage/QuickPhraseManage.vue'),
                        },
                        {
                            path: 'moment-manage',
                            name: 'groupchat-moment-manage',
                            meta: { title: '动态管理', icon: 'Picture' },
                            component: () => import('@/views/GroupchatManage/MomentManage.vue'),
                        },
                        {
                            path: 'vip-order',
                            name: 'groupchat-vip-order',
                            meta: { title: 'VIP购买记录', icon: 'Money' },
                            component: () => import('@/views/GroupchatManage/ShanyanVipOrderList.vue'),
                        },
                        {
                            path: 'private-message',
                            name: 'groupchat-private-message',
                            meta: { title: '私信记录', icon: 'Message' },
                            component: () => import('@/views/GroupchatManage/PrivateMessageList.vue'),
                        },
                    ]
                },
                {
                    path: 'activity',
                    name: 'activity',
                    meta: { title: '活动管理', icon: 'Present' },
                    component: { render: h => h('router-view') },
                    redirect: '/activity/organizer-audit',
                    children: [
                        {
                            path: 'organizer-audit',
                            name: 'activity-organizer-audit',
                            meta: { title: '主理人审核', icon: 'User' },
                            component: () => import('@/views/ActivityManage/OrganizerAudit.vue'),
                        },
                        {
                            path: 'list',
                            name: 'activity-list',
                            meta: { title: '活动列表', icon: 'List' },
                            component: () => import('@/views/ActivityManage/ActivityList.vue'),
                        },
                        {
                            path: 'registrations',
                            name: 'activity-registrations',
                            meta: { title: '报名管理', icon: 'Document' },
                            component: () => import('@/views/ActivityManage/RegistrationList.vue'),
                        },
                        {
                            path: 'organizer-list',
                            name: 'activity-organizer-list',
                            meta: { title: '主理人列表', icon: 'UserFilled' },
                            component: () => import('@/views/ActivityManage/OrganizerList.vue'),
                        },
                    ]
                },
                {
                    path: 'system',
                    name: 'system',
                    meta: {title: '系统管理', icon: 'Setting'},
                    component: {render: h => h('router-view')},
                    redirect: '/system/tag-manage',
                    children: [
                        {
                            path: 'admin-list',
                            name: 'system-admin-list',
                            meta: {title: '管理员列表', icon: 'User'},
                            component: () => import('@/views/System/AdminList.vue'),
                        },
                        {
                            path: 'message-notify-manage',
                            name: 'system-message-notify-manage',
                            meta: { title: '消息提示管理', icon: 'Bell' },
                            component: () => import('@/views/System/MessageNotifyManage.vue'),
                        },
                        {
                            path: 'message-receiver-manage',
                            name: 'system-message-receiver-manage',
                            meta: { title: '消息管理', icon: 'Message' },
                            component: () => import('@/views/System/MessageReceiverManage.vue'),
                        },
                        {
                            path: 'message-template-manage',
                            name: 'system-message-template-manage',
                            meta: { title: '模板链接管理', icon: 'Link' },
                            component: () => import('@/views/System/MessageTemplateManage.vue'),
                        },
                        {
                            path: 'password',
                            name: 'Password',
                            component: () => import('@/views/System/Password.vue'),
                            meta: {title: '修改操作码'}
                        },
                        {
                            path: 'tag-manage',
                            name: 'system-tag-manage',
                            meta: {title: '标签管理', icon: 'Tag'},
                            component: () => import('@/views/System/TagManage.vue'),
                        },
                        {
                            path: 'keyword-manage',
                            name: 'system-keyword-manage',
                            meta: { title: '关键字管理', icon: 'Edit' },
                            component: { render: h => h('router-view') },
                            redirect: '/system/keyword-manage/list',
                            children: [
                                {
                                    path: 'list',
                                    name: 'keyword-list',
                                    component: () => import('@/views/System/KeywordManage/List.vue'),
                                    meta: { title: '关键字列表', icon: 'Menu' }
                                },
                                {
                                    path: 'edit/:id?',
                                    name: 'keyword-edit',
                                    component: () => import('@/views/System/KeywordManage/Edit.vue'),
                                    meta: { title: '编辑关键字', icon: 'Edit' },
                                    hidden: true // 不显示在侧边栏，只在页面内跳转用
                                }
                            ]
                        },
                        {
                            path: 'share-config',
                            name: 'system-share-config',
                            meta: { title: '分享配置', icon: 'Picture' },
                            component: () => import('@/views/System/ShareConfig.vue'),
                        },
                        //测试页面
                         {
                             path: 'test',
                             component: () => import('@/views/System/Test.vue'),
                             meta: { title: '测试页面', icon: 'Test' }
                         },
                         {
                             path: 'customer-service',
                             name: 'system-customer-service',
                             meta: { title: '客服管理', icon: 'Service' },
                             component: () => import('@/views/System/CustomerServiceManage.vue'),
                         },
                         {
                             path: 'role-permission',
                             name: 'system-role-permission',
                             meta: { title: '角色权限管理', icon: 'Lock' },
                             component: () => import('@/views/System/RolePermission.vue'),
                         },
                         {
                             path: 'staff-list',
                             name: 'system-staff-list',
                             meta: { title: '员工管理', icon: 'UserFilled' },
                             component: () => import('@/views/System/StaffList.vue'),
                         },
                         {
                             path: 'branch-role',
                             name: 'system-branch-role',
                             meta: { title: '角色管理', icon: 'SCustom' },
                             component: () => import('@/views/System/BranchRole.vue'),
                         },
                          {
                             path: 'vip-price',
                             name: 'system-vip-price',
                             meta: { title: '会员价格', icon: 'Ticket' },
                             component: () => import('@/views/System/VipPrice.vue'),
                         },
                         {
                             path: 'withdraw-config',
                             name: 'system-withdraw-config',
                             meta: { title: '提现管理', icon: 'Money' },
                             component: () => import('@/views/System/WithdrawConfig.vue'),
                         },
                         {
                             path: 'fare-config',
                             name: 'system-fare-config',
                             meta: { title: '路费配置', icon: 'Van' },
                             component: () => import('@/views/System/FareConfig.vue'),
                         },
                         {
                             path: 'page-hotspot',
                             name: 'system-page-hotspot',
                             meta: { title: '页面热区配置', icon: 'Picture' },
                             component: () => import('@/views/System/PageHotspotConfig.vue'),
                         },
                         {
                             path: 'page-setting',
                             name: 'system-page-setting',
                             meta: { title: '页面设置', icon: 'Monitor' },
                             component: { render: h => h('router-view') },
                             redirect: '/system/page-setting/list',
                             children: [
                                 {
                                     path: 'list',
                                     name: 'page-setting-list',
                                     meta: { title: '页面设置', icon: 'Monitor' },
                                     component: () => import('@/views/System/PageSettingList.vue'),
                                 },
                                 {
                                     path: 'edit/:pageKey',
                                     name: 'page-setting-edit',
                                     meta: { title: '编辑页面设置', icon: 'Edit' },
                                     component: () => import('@/views/System/PageSettingEdit.vue'),
                                     hidden: true,
                                 }
                             ]
                         }
                    ]
                },
                {
                    path: 'message-manage',
                    name: 'message-manage',
                    meta: { title: '留言管理', icon: 'ChatLineRound' },
                    component: () => import('@/views/MessageManage/MessageManage.vue'),
                },
                {
                    path: 'audit-manage',
                    name: 'audit-manage',
                    meta: { title: '审核管理', icon: 'DocumentChecked' }, // 新的 icon
                    component: {render: h => h('router-view')},
                    redirect: 'audit-manage/player',
                    children: [
                        {
                            path: 'player',
                            name: 'audit-player',
                            meta: { title: '达人审核', icon: 'User' },
                            component: () => import('@/views/AuditManage/PlayerAudit.vue'),
                        },
                        {
                            path: 'file',
                            name: 'audit-file',
                            meta: { title: '文件审核', icon: 'Document' },
                            component: () => import('@/views/AuditManage/FileAudit.vue'),
                        },
                        {
                            path: 'order-publish',
                            name: 'audit-order-publish',
                            meta: { title: '发单审核', icon: 'DocumentAdd' },
                            component: () => import('@/views/AuditManage/OrderPublishAudit.vue'),
                        },
                    ],
                },
                {
                    path: 'video-manage',
                    name: 'video-manage',
                    meta: { title: '达人视频', icon: 'VideoCamera' },
                    component: {render: h => h('router-view')},
                    redirect: 'video-manage/audit',
                    children: [
                        {
                            path: 'audit',
                            name: 'video-audit',
                            meta: { title: '视频审核', icon: 'DocumentChecked' },
                            component: () => import('@/views/AuditManage/VideoAudit.vue'),
                        },
                        {
                            path: 'upload',
                            name: 'video-upload',
                            meta: { title: '上传视频', icon: 'Upload' },
                            component: () => import('@/views/AuditManage/PlayerVideoUpload.vue'),
                        },
                        {
                            path: 'query',
                            name: 'video-query',
                            meta: { title: '视频管理', icon: 'Search' },
                            component: () => import('@/views/AuditManage/PlayerVideoQuery.vue'),
                        },
                    ],
                },
                {
                    path: 'qrcode',
                    name: 'qrcode',
                    meta: {title: '二维码管理', icon: 'QRCode'},
                    component: {render: h => h('router-view')},
                    redirect: '/qrcode/list',
                    children: [
                        {
                            path: 'list',
                            name: 'qrcode-list',
                            meta: {title: '二维码列表', icon: 'List'},
                            component: () => import('@/views/QrCodeManage/QrCodeList.vue'),
                        },
                        // 可以在此继续扩展其他二维码相关页面
                    ]
                },
                {
                    path: '/order-publish',
                    name: 'order-publish',
                    meta: { title: '发单管理', icon: 'DocumentAdd' },
                    redirect: '/order-publish/list',
                    component: {render: h => h('router-view')},
                    children: [
                        {
                            path: 'list',
                            name: 'order-publish-list',
                            meta: { title: '发单列表' },
                            component: () => import('@/views/OrderPublish/PublishList.vue'),
                        },
                        {
                            path: 'nearby',
                            name: 'order-publish-nearby',
                            meta: { title: '发单附近达人' },
                            component: () => import('@/views/OrderPublish/NearbyTalent.vue'),
                        },
                    ],
                },
                {
                    path: 'trace',
                    name: 'trace',
                    meta: { title: '轨迹查询', icon: 'LocationInformation' },
                    component: { render: h => h('router-view') },
                    redirect: '/trace/city-cooperation',
                    children: [
                        {
                            path: 'city-cooperation',
                            name: 'trace-city-cooperation',
                            meta: { title: '城市合作', icon: 'OfficeBuilding' },
                            component: () => import('@/views/Trace/CityCooperation.vue'),
                        }
                    ]
                },
                {
                    path: 'front-config',
                    name: 'front-config',
                    meta: { title: '前端设置', icon: 'Monitor' },
                    component: { render: h => h('router-view') },
                    redirect: '/front-config/home',
                    children: [
                        {
                            path: 'home',
                            name: 'front-config-home',
                            meta: { title: '首页设置', icon: 'House' },
                            component: () => import('@/views/System/HomeConfig.vue'),
                        },
                        {
                            path: 'fee-setting',
                            name: 'front-config-fee-setting',
                            meta: { title: '费用设置', icon: 'Money' },
                            component: () => import('@/views/System/FeeSetting.vue'),
                        }
                    ]
                },


            ]
        }

    ]
})

// 路由守卫：未登录时跳转到登录页
router.beforeEach((to, from, next) => {
    const noAuthPages = ['/login', '/callback']
    const token = localStorage.getItem('molv_token')
    if (!token && !noAuthPages.includes(to.path)) {
        next('/login')
    } else {
        next()
    }
})

export default router
